import { NavLink } from 'react-router-dom';
import { Home, Calendar, Dumbbell, UtensilsCrossed, Snowflake, BarChart3, Settings, Lock } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { hasTier } from '@/lib/tiers';
import { RegenLogo } from './RegenLogo';

const items = [
  { to: '/app/home', label: 'Home', icon: Home, testid: 'nav-home' },
  { to: '/app/calendar', label: 'Calendar', icon: Calendar, testid: 'nav-calendar' },
  { to: '/app/training', label: 'Training', icon: Dumbbell, testid: 'nav-training' },
  { to: '/app/nutrition', label: 'Nutrition', icon: UtensilsCrossed, testid: 'nav-nutrition' },
  { to: '/app/recovery', label: 'Recovery', icon: Snowflake, testid: 'nav-recovery' },
  { to: '/app/progress', label: 'Progress', icon: BarChart3, testid: 'nav-progress' },
  { to: '/app/settings', label: 'Settings', icon: Settings, testid: 'nav-settings' },
];

// Phones: bottom tab bar. Laptops/desktops (lg+): fixed left sidebar.
export function BottomNav() {
  const { user } = useAuth();
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 glass safe-bottom border-t border-[var(--c-hair)] lg:top-0 lg:right-auto lg:w-60 lg:border-t-0 lg:border-r lg:flex lg:flex-col" data-testid="app-nav">
      <div className="hidden lg:block px-6 pt-8 pb-8"><RegenLogo size="sm" /></div>
      <div className="max-w-2xl mx-auto px-2 py-2 grid grid-cols-7 gap-1 lg:max-w-none lg:mx-0 lg:px-3 lg:py-0 lg:flex lg:flex-col lg:gap-1.5">
        {items.map(({ to, label, icon: Icon, testid, needed }) => {
          const locked = needed && !hasTier(user?.subscription_tier, needed);
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              data-locked={locked ? 'true' : 'false'}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center py-1.5 rounded-xl transition-colors lg:flex-row lg:justify-start lg:gap-3 lg:px-4 lg:py-3 ${
                  isActive ? 'text-[#00C8FF] lg:bg-[#00C8FF]/10' : 'text-muted-foreground hover:text-foreground lg:hover:bg-[var(--c-elev2)]'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#00C8FF] shadow-[0_0_12px_rgba(0,200,255,0.8)] lg:top-2 lg:bottom-2 lg:left-0 lg:h-auto lg:w-1" />}
                  <div className="relative">
                    <Icon className={`w-5 h-5 ${locked ? 'opacity-50' : ''}`} strokeWidth={isActive ? 2.5 : 1.8} />
                    {locked && (
                      <span className="absolute -top-1.5 -right-2 w-3.5 h-3.5 rounded-full bg-[var(--c-elev2)] border border-[var(--c-hair)] flex items-center justify-center" data-testid={`${testid}-lock`}>
                        <Lock className="w-2 h-2 text-[#00C8FF]" />
                      </span>
                    )}
                  </div>
                  <span className={`text-[10px] mt-0.5 font-medium lg:text-[15px] lg:mt-0 ${locked ? 'opacity-50' : ''}`}>{label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
